import React from 'react'

import { useSession } from '@rewardops/auth'

import '@rewardops/replit/src/styles.css'

import { GenericPAWDashboard } from './generic-paw-dashboard'
import { PAWDashboardSidebar } from './sidebar'

type DashboardContentProps = {
  role: string
  sections: {
    id: string
    sectionId: string
  }
}

type DashboardProps = {
  role: string
  content: DashboardContentProps
}

const Dashboard: React.FC<DashboardProps> = ({
  role,
  content,
}: DashboardProps) => {
  return <GenericPAWDashboard content={content} role={role} />
}

type ElpRoleBasedDashboardProps = {
  content: DashboardContentProps
}

const ElpRoleBasedDashboard: React.FC<ElpRoleBasedDashboardProps> = ({
  content,
}: ElpRoleBasedDashboardProps) => {
  const { data: session } = useSession()

  const role = session?.user?.member?.role

  if (!Boolean(session) || !role) {
    return null
  }

  return (
    <div className="paw-dashboard">
      <div
        className={
          'group/sidebar-wrapper has-data-[variant=inset]:bg-sidebar min-h-svh flex w-full flex-col md:flex-row'
        }
      >
        <PAWDashboardSidebar content={content} />
        <div id="paw-main" className="flex-1 space-y-8">
          <Dashboard role={role ?? ''} content={content} />
        </div>
      </div>
    </div>
  )
}

export { ElpRoleBasedDashboard }
